import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { GridRenderCellParams } from "@mui/x-data-grid";
import * as React from "react";


interface CustomRenderCellProps extends GridRenderCellParams<any, any> {
    realValue: number;
}
function CustomRenderCell(params: CustomRenderCellProps) {
    let val = params.realValue || params.value;
    if (isNaN(val)) {
        val = null;
    }
    return (
        <Tooltip title={params.value}>
            <Typography
                variant="inherit"
                component="span"
                color={ params.realValue === params.value ? "black" : "gray" }
            >
                {val === null && ""}
                {val !== null && val.toLocaleString('ru-RU')}
            </Typography>
        </Tooltip>
    );
}


export default CustomRenderCell;
